/**
 * BEPRO Shop - Add to Cart funkcionalnost
 * Radi na shop-product stranici (/shop/{slug}/)
 */
import Cart from './cart';
import { showToast } from './toast';

export default function AddToCart() {
	const form = document.querySelector('.js-add-to-cart-form');
	if (!form) return;

	const productId = form.dataset.productId;
	const productTitle = form.dataset.productTitle;
	const productImage = form.dataset.productImage || '';
	const productUrl = form.dataset.productUrl || '';
	const currency = form.dataset.currency || 'KM';

	const sizeSelect = form.querySelector('.js-add-to-cart-size');
	const colorSelect = form.querySelector('.js-add-to-cart-color');
	const colorHiddenInput = form.querySelector('.js-add-to-cart-color-value');
	const quantityInput = form.querySelector('.js-add-to-cart-quantity');
	const addButton = form.querySelector('.js-add-to-cart-btn');
	const priceDisplay = form.querySelector('.js-add-to-cart-price');

	if (!addButton) return;

	// Količina +/- dugmad
	const minusBtn = form.querySelector('.js-atc-qty-minus');
	const plusBtn = form.querySelector('.js-atc-qty-plus');
	if (minusBtn && quantityInput) {
		minusBtn.addEventListener('click', () => {
			const val = parseInt(quantityInput.value) || 1;
			quantityInput.value = Math.max(1, val - 1);
		});
	}
	if (plusBtn && quantityInput) {
		plusBtn.addEventListener('click', () => {
			const val = parseInt(quantityInput.value) || 1;
			quantityInput.value = Math.min(99, val + 1);
		});
	}

	// Ažuriraj cijenu pri promjeni veličine
	if (sizeSelect) {
		sizeSelect.addEventListener('change', () => {
			const selected = sizeSelect.options[sizeSelect.selectedIndex];
			const price = selected ? selected.dataset.price : '0';
			if (priceDisplay) {
				priceDisplay.textContent = parseFloat(price).toFixed(2) + ' ' + currency;
			}
		});
	}

	// Color swatches (na shop-product stranici)
	const colorSwatches = form.querySelectorAll('.js-shop-color-swatch');
	if (colorSwatches.length > 0) {
		colorSwatches.forEach(swatch => {
			swatch.addEventListener('click', () => {
				colorSwatches.forEach(s => s.classList.remove('is-active'));
				swatch.classList.add('is-active');
				if (colorHiddenInput) {
					colorHiddenInput.value = swatch.dataset.color;
				}
			});
		});
	}

	addButton.addEventListener('click', (e) => {
		e.preventDefault();

		// Šalji čisti naziv modela (option value, npr. "CANNA L"), NE label sa
		// cijenom ("CANNA L — 127.51 KM") — server validira cijenu poređenjem
		// size polja sa ACF price model imenom (class-shop-orders.php, C5).
		const size = sizeSelect ? sizeSelect.value : '';
		const price = sizeSelect ? sizeSelect.options[sizeSelect.selectedIndex]?.dataset.price : '0';

		// Boja: iz swatcheva ili select dropdowna
		let color = '';
		if (colorHiddenInput) {
			color = colorHiddenInput.value;
		} else if (colorSelect) {
			color = colorSelect.options[colorSelect.selectedIndex]?.text || '';
		}

		const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

		if (sizeSelect && sizeSelect.options.length > 1 && !sizeSelect.value) {
			sizeSelect.classList.add('is-error');
			return;
		}

		Cart.addItem({
			id: productId,
			title: productTitle,
			image: productImage,
			url: productUrl,
			size: size,
			color: color,
			price: parseFloat(price) || 0,
			quantity: quantity,
			currency: currency,
		});

		// Toast notifikacija
		showToast(productTitle + " dodan u korpu", "success", 3000);
	});
}
